module.exports = __webpack_public_path__ + "static/media/44.e2b8926c.png";